import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
} from '@mui/material';
import { FunctionComponent, useState } from 'react';
import _ from 'lodash';
import { WeightEntity } from '../types/weight';
import { addWeight } from '../api/addWeight';
import { useMutation, useQueryClient } from 'react-query';
import AddIcon from '@mui/icons-material/Add';

export const AddWeightButton: FunctionComponent<{}> = () => {
  const queryClient = useQueryClient();
  const addMutation = useMutation(addWeight, {
    onSuccess: () => queryClient.invalidateQueries('weights'),
  });

  const [open, setOpen] = useState(false);
  const [weight, setWeight] = useState('');
  const inputInvalid = !weight || !+weight;

  const addChar = (input: string | number) => () =>
    setWeight((w) => w + input.toString());

  const removeChar = () => setWeight((w) => w.substring(0, w.length - 1));

  const save = async () => {
    if (inputInvalid) return;

    const newWeight = new WeightEntity(+weight);

    addMutation.mutate(newWeight, {
      onSuccess: () => setOpen(false),
    });
  };

  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        <AddIcon />
      </IconButton>

      <Dialog open={open}>
        <DialogTitle>Add Weight</DialogTitle>
        <DialogContent>
          <TextField
            label="Weight"
            value={weight}
            onChange={(e) => setWeight(e.target.value)}
            inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            sx={{ mb: 2, width: 220 }}
          />

          <Grid
            container
            rowSpacing={2}
            width={220}
            justifyContent="space-between"
          >
            {_.range(1, 10).map((k) => (
              <Grid key={k} item>
                <Button
                  variant="outlined"
                  onClick={addChar(k)}
                  sx={{ height: 64, fontSize: 40 }}
                >
                  {k}
                </Button>
              </Grid>
            ))}
            <Grid item>
              <Button
                variant="outlined"
                onClick={removeChar}
                sx={{ height: 64, fontSize: 40 }}
              >
                {'<'}
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={addChar(0)}
                sx={{ height: 64, fontSize: 40 }}
              >
                0
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={addChar('.')}
                sx={{ height: 64, fontSize: 40 }}
              >
                .
              </Button>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container justifyContent="space-between" mb={1}>
            <Button color="error" sx={{ ml: 2 }} onClick={() => setOpen(false)}>
              Cancel
            </Button>
            <Button sx={{ mr: 2 }} onClick={save} disabled={inputInvalid}>
              Save
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  );
};
